/* Pure Vitamins UK homepage behaviour.
   No libraries. Idempotent: safe to re-run in the theme editor.
   Add to basket is handled by the theme's own <product-form> element,
   so no cart logic is duplicated here. */
(function () {
  'use strict';
  if (window.__pvHomeInit) return;
  window.__pvHomeInit = true;

  var reduce = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  /* True on mice and trackpads, false on touch-only devices. Touch browsers
     fire mouseenter on tap but often never fire the matching mouseleave, which
     would leave a hover-paused rotator frozen for the rest of the session. */
  var hoverCapable = function () {
    return !(window.matchMedia && window.matchMedia('(hover: none)').matches);
  };

  /* ---------- Announcement rotator ---------- */
  function initAnnouncement(root) {
    if (root.dataset.pvReady === '1') return;
    root.dataset.pvReady = '1';

    var msgs = Array.prototype.slice.call(root.querySelectorAll('.pv-ann__msg'));
    if (msgs.length < 2) return;

    var i = 0;
    var timer = null;
    var delay = Math.max(4000, parseInt(root.dataset.interval, 10) || 6000);

    function show(n) {
      i = (n + msgs.length) % msgs.length;
      msgs.forEach(function (m, idx) {
        m.setAttribute('data-active', idx === i ? 'true' : 'false');
      });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (msgs.length < 2) return;
      timer = setInterval(function () { show(i + 1); }, delay);
    }

    root.querySelectorAll('[data-pv-ann-prev]').forEach(function (b) {
      b.addEventListener('click', function () { show(i - 1); start(); });
    });
    root.querySelectorAll('[data-pv-ann-next]').forEach(function (b) {
      b.addEventListener('click', function () { show(i + 1); start(); });
    });

    /* Pause on hover only where hover is real. Keyboard focus always pauses,
       which is what WCAG 2.2.2 actually needs, and it cannot get stuck. */
    if (hoverCapable()) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
    }
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    show(0);
    start();
  }

  /* ---------- Hero carousel ---------- */
  function initHero(root) {
    if (root.dataset.pvReady === '1') return;
    root.dataset.pvReady = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.pv-hero__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.pv-hero__dot'));
    if (slides.length < 2) return;

    var i = 0;
    var timer = null;
    var autoplay = root.dataset.autoplay === 'true';
    var delay = Math.max(6000, parseInt(root.dataset.interval, 10) || 8000);

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) {
        var on = idx === i;
        s.setAttribute('data-active', on ? 'true' : 'false');
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('a,button').forEach(function (el) {
          if (on) { el.removeAttribute('tabindex'); } else { el.setAttribute('tabindex', '-1'); }
        });
      });
      dots.forEach(function (d, idx) {
        d.setAttribute('aria-selected', idx === i ? 'true' : 'false');
        d.setAttribute('tabindex', idx === i ? '0' : '-1');
      });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (!autoplay || reduce()) return;
      timer = setInterval(function () { show(i + 1); }, delay);
    }

    root.querySelectorAll('[data-pv-hero-prev]').forEach(function (b) {
      b.addEventListener('click', function () { show(i - 1); start(); });
    });
    root.querySelectorAll('[data-pv-hero-next]').forEach(function (b) {
      b.addEventListener('click', function () { show(i + 1); start(); });
    });
    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () { show(idx); start(); });
      d.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(i + 1); dots[i].focus(); start(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(i - 1); dots[i].focus(); start(); }
        if (e.key === 'Home') { e.preventDefault(); show(0); dots[0].focus(); start(); }
        if (e.key === 'End') { e.preventDefault(); show(slides.length - 1); dots[slides.length - 1].focus(); start(); }
      });
    });
    if (hoverCapable()) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
    }
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    show(0);
    start();
  }

  /* ---------- Horizontal rail navigation ---------- */
  function initRail(root) {
    if (root.dataset.pvReady === '1') return;
    root.dataset.pvReady = '1';

    var rail = root.querySelector('.pv-rail');
    var prev = root.querySelector('[data-pv-rail-prev]');
    var next = root.querySelector('[data-pv-rail-next]');
    if (!rail) return;

    function step() {
      var first = rail.firstElementChild;
      if (!first) return rail.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(rail).columnGap || '16') || 16;
      return first.getBoundingClientRect().width + gap;
    }
    function sync() {
      if (!prev || !next) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
      var hide = rail.scrollWidth <= rail.clientWidth + 4;
      prev.hidden = hide;
      next.hidden = hide;
    }
    function go(dir) {
      rail.scrollBy({ left: dir * step(), behavior: reduce() ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    rail.addEventListener('scroll', function () {
      window.requestAnimationFrame(sync);
    }, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  }

  /* ---------- Optional: open Shopify Inbox chat if present ---------- */
  function initChat(link) {
    if (link.dataset.pvReady === '1') return;
    link.dataset.pvReady = '1';
    link.addEventListener('click', function (e) {
      var launcher = document.querySelector('#ShopifyChat, #shopify-chat, .shopify-chat-button, [id^="shopify-chat"] button');
      if (launcher) {
        e.preventDefault();
        launcher.click();
      }
    });
  }

  function boot(scope) {
    var d = scope || document;
    d.querySelectorAll('[data-pv-announcement]').forEach(initAnnouncement);
    d.querySelectorAll('[data-pv-hero]').forEach(initHero);
    d.querySelectorAll('[data-pv-rail-root]').forEach(initRail);
    d.querySelectorAll('[data-pv-chat]').forEach(initChat);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Theme editor: re-init sections as they are loaded or changed. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
